import { useEffect } from "react";
import { Hero } from "@/components/isic/Hero";
import { InfoColumns } from "@/components/isic/InfoColumns";
import { BlueSection } from "@/components/isic/BlueSection";
import { AliveApp } from "@/components/isic/AliveApp";
import { RomaniaDiscounts, InternationalDiscounts } from "@/components/isic/Discounts";
import { PromoSlider } from "@/components/isic/PromoSlider";
import { ContactSection } from "@/components/isic/ContactSection";

export default function PartnerPage({ config }) {
  useEffect(() => {
    if (config.title) document.title = config.title;
  }, [config.title]);

  return (
    <main className="w-full bg-white" data-testid="landing-page">
      <Hero banner={config.banner} />
      <InfoColumns info={config.info} />
      <BlueSection bigBlock={config.bigBlock} />
      <AliveApp />
      <RomaniaDiscounts />
      <InternationalDiscounts />
      <PromoSlider />
      <ContactSection />
    </main>
  );
}
